import React from "react";

export default function Hero() {
  return (
    <div className="hero">
        {/* <img src="/images/Frame61.png" alt="MM Easy Access logo" /> */}
        <div className="hero-overlay">
            <h1>Serwis Drzwi Automatycznych</h1>
            <p className="subtitle">Serwis, któremu możesz zaufać</p>
        </div>
    </div>
  );
}
